import React from 'react';
import { styled } from '@linaria/react';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
type PropsType = {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** If the users search is for more than one room */
  includeTaxes: boolean;
  /** If supplied it will add the currency code to the message */
  currencyCode?: string;
  /** If supplied it will show the PriceMessage */
  showPriceMessage?: boolean;
};
export const GuestMessage = /*#__PURE__*/styled('span')({
  name: "GuestMessage",
  class: "g1mtfnhw",
  propsAsIs: false
});
const TaxDisplay = /*#__PURE__*/styled('span')({
  name: "TaxDisplay",
  class: "tnstz9i",
  propsAsIs: false
});
export const PriceMessageWrapper = /*#__PURE__*/styled('span')({
  name: "PriceMessageWrapper",
  class: "p1r3c4xt",
  propsAsIs: false
});
export const TaxationAndNightlyPriceMessage = ({
  includeTaxes,
  currencyCode,
  className,
  showPriceMessage = true
}: PropsType) => {
  if (!showPriceMessage && !includeTaxes && !currencyCode) {
    return null;
  }
  return <TaxDisplay data-id="NightlyPriceLabel" className={className}>
      {showPriceMessage && <>
          <PriceMessageWrapper>
            <FormattedMessageWrapper id="nightlyPrice" defaultMessage="Nightly price" />
          </PriceMessageWrapper>
        </>}
      {includeTaxes && <>
          {showPriceMessage && <>&nbsp;</> || null}
          <FormattedMessageWrapper id="includingTaxes" defaultMessage="incl taxes and fees" />
        </>}
      {currencyCode && <>
          <>&nbsp;</>
          <FormattedMessageWrapper id="inCurrency" defaultMessage="in {currencyCode}" values={{
        currencyCode
      }} />
        </>}
    </TaxDisplay>;
};

require("./TaxationAndNightlyPriceMessage.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TaxationAndNightlyPriceMessage.tsx");